import { useState } from "react";
import { GraduationCap, Users } from "lucide-react";
import FreeEducationContentEditor from "@/components/admin/FreeEducationEditor";
import FreeEducationSubscribers from "@/components/admin/FreeEducationSubscribers";

export default function FreeEducationPanel() {
  const [tab, setTab] = useState("subscribers");
  const tabs = [
    { k: "subscribers", l: "Subscribers", Icon: Users, C: FreeEducationSubscribers },
    { k: "content",     l: "Page content", Icon: GraduationCap, C: FreeEducationContentEditor },
  ];
  const Active = (tabs.find((t) => t.k === tab) || tabs[0]).C;
  return (
    <div className="space-y-6" data-testid="admin-free-education-wrap">
      <div>
        <div className="overline">Free Education</div>
        <p className="text-sm text-[hsl(var(--onyx)/0.6)] mt-1 max-w-2xl">
          NøoksPro Free Education signups, welcome-email status and the /free-education page copy — all in one place.
        </p>
      </div>
      <div className="flex gap-1.5 flex-wrap">
        {tabs.map(({ k, l, Icon }) => (
          <button
            key={k}
            onClick={() => setTab(k)}
            data-testid={`fe-panel-tab-${k}`}
            className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-xs uppercase tracking-widest transition-colors ${
              tab === k
                ? "bg-[hsl(var(--onyx))] text-[hsl(var(--cream))]"
                : "bg-white border border-[hsl(var(--onyx)/0.1)] text-[hsl(var(--onyx)/0.7)] hover:border-[hsl(var(--onyx)/0.3)]"
            }`}
          >
            <Icon size={12} /> {l}
          </button>
        ))}
      </div>
      <Active />
    </div>
  );
}
